module.exports = __webpack_public_path__ + "static/media/timeline-copy-3.aa7e1000.png";